import React from 'react';
import { useLinkGatewayCustomerToAccount } from '../../../api/accountsService';
import { useGetGatewayCustomerAccount } from '../../../api/paymentsService';
import {
  MButton,
  MCenterModal,
  MFormField,
  MGrid,
  MGridItem,
  MStack,
  MText,
} from '../../../components/Monetize';
import { useToast } from '../../../services/toast';

interface GatewayAccountDetailsModalProps {
  onClose: () => void;
  accountId: string;
  paymentGatewayId: string;
  gatewayCustomerId: string;
}

export const GatewayAccountDetailsModal: React.FC<
  GatewayAccountDetailsModalProps
> = ({ onClose, accountId, paymentGatewayId, gatewayCustomerId }) => {
  const { addToast } = useToast();

  const { data: gatewayCustomerData, isLoading } = useGetGatewayCustomerAccount(
    paymentGatewayId,
    gatewayCustomerId,
    {
      enabled: !!gatewayCustomerId,
    },
  );

  const { mutateAsync: linkGatewayCustomer, isPending } =
    useLinkGatewayCustomerToAccount({
      onSuccess: () => {
        addToast({
          summary: 'Link Gateway Account',
          detail:
            'The payment gateway account has been linked to this customer',
          severity: 'success',
          timeTaken: 10000,
        });
        onClose();
      },
      meta: { showErrorToast: true },
    });

  const handleLinkCustomer = () => {
    linkGatewayCustomer({
      accountId,
      paymentGatewayId,
      gatewayCustomerId,
    });
  };

  return (
    <MCenterModal
      isOpen
      onClose={onClose}
      modalTitle="Payment Account Details"
      size="lg"
      isLoading={isLoading}
      renderFooter={() => (
        <MStack gap={4} direction="row" align="center" justify="end" flex={1}>
          <MButton onClick={onClose} variant="cancel" minW="auto">
            Cancel
          </MButton>

          <MButton
            isLoading={isPending}
            variant="primary"
            minW="auto"
            onClick={handleLinkCustomer}
            isDisabled={!gatewayCustomerData}
          >
            Link Customer
          </MButton>
        </MStack>
      )}
    >
      {gatewayCustomerData && (
        <MGrid templateColumns="repeat(12, 1fr)">
          <MGridItem colSpan={6}>
            <MFormField label="Gateway Account ID">
              <MText mt=".3rem">{gatewayCustomerData.gatewayAccount.id}</MText>
            </MFormField>
          </MGridItem>
          <MGridItem colSpan={6}>
            <MFormField label="Account Name">
              <MText mt=".3rem">
                {gatewayCustomerData.gatewayAccount.name}
              </MText>
            </MFormField>
          </MGridItem>
        </MGrid>
      )}
    </MCenterModal>
  );
};
